'use strict';

var extend = require('extend');
var Slide = require('./GallerySlide.js');
var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

function Gallery(config) {
	this.config = extend({}, {
		component: 'gallery',
		thumb: 'galleryThumb__image',
		previous: 'gallery--previous',
		next: 'gallery--next',
		activeClassModifier: 'active'
	}, config);
}

Gallery.prototype.init = function () {
	this.component = document.querySelector('.' + this.config.component);
	if (this.component === null) return;

	this.build();
	this.activate();
};

Gallery.prototype.build = function() {
	this.thumbs = this.component.querySelectorAll('.' + this.config.thumb);
	if (!this.thumbs.length) return;

	this.activeSlide = 0;
	this.slides = [];
	for (var i = 0; i < this.thumbs.length; i++) {
		var imageSrc = this.thumbs[i].getAttribute('href');
		var altText = this.thumbs[i].getAttribute('data-alt') || '';
		var titleText = this.thumbs[i].getAttribute('data-title') || '';
		var captionText = this.thumbs[i].getAttribute('data-caption') || '';
		var active = i === 0;

		this.slides.push(
			new Slide(
				this.thumbs[i], {
					imageSrc: imageSrc,
					altText: altText,
					titleText: titleText,
					captionText: captionText
				}
			)
		);
	}
}

Gallery.prototype.activate = function() {
	var that = this;
	if (!this.thumbs.length) return;

	this.thumbs.forEach(function(element, index) {
		element.addEventListener('click', function(event) {
			event.preventDefault();

			// Change slide only if selection actually changes
			if (that.activeSlide !== index) {
				that.changeSlide(index);
				// that.analytics.trackEvent('Gallery', 'Click', 'Thumbnail');
			}
		});
	});

	var previousBtn = this.component.querySelector('.' + this.config.previous);
	previousBtn.addEventListener('click', function(event) {

		if (that.activeSlide === 0) {
			that.changeSlide(that.slides.length - 1);
		} else {
			that.changeSlide(that.activeSlide - 1);
		}
		myAnalytics.trackEvent('Gallery', 'Click', 'Previous');
	});
	var nextBtn = this.component.querySelector('.' + this.config.next);
	nextBtn.addEventListener('click', function(event) {
		if (that.activeSlide === that.slides.length - 1) {
			that.changeSlide(0);
		} else {
			that.changeSlide(that.activeSlide + 1);
		}
		myAnalytics.trackEvent('Gallery', 'Click', 'Next');
	});
}

Gallery.prototype.changeSlide = function (index) {
	this.activeSlide = index;

	this.activateNewImage(index);
	this.activateNewThumb(index);
}

Gallery.prototype.activateNewImage = function (index) {
	var frame = this.component.querySelector('figure');

	// Remove old
	var imgFrame = frame.querySelector('.gallery__image');
	var oldImg = imgFrame.querySelectorAll('img');
	for (var i = 0; i < oldImg.length; i++) {
		imgFrame.removeChild(oldImg[i])
	}

	var oldCaption = frame.querySelector('figcaption');
	if (oldCaption) {
		frame.removeChild(oldCaption);
	}

	this.slides[index].appendElements(imgFrame, frame);

	// Add New
	// imgFrame.appendChild(this.slides[index].imgFluid);
	// if (this.slides[index].caption) {
	// 	frame.appendChild(this.slides[index].caption);
	// }
};

Gallery.prototype.activateNewThumb = function (index) {
	var oldThumb = this.component.querySelector('.' + this.config.thumb + '--' + this.config.activeClassModifier);
	oldThumb.classList.remove(this.config.thumb + '--' + this.config.activeClassModifier);

	var newThumb = this.thumbs[index];
	newThumb.classList.add(this.config.thumb + '--' + this.config.activeClassModifier);
};

module.exports = Gallery;
